import React, { FC } from 'react'
import useQA from 'hooks/useQA'
import FilterIcon from 'svg/filter-v2.svg'
import styles from '../Filters.module.scss'
import Skeleton from 'components/SA/Skeleton'
import useIsMobile from 'hooks/useIsMobile'
import useAvoidLayoutShift from 'hooks/useAvoidLayoutShift'

type FilterButtonProps = {
  isFiltersVisible?: boolean
  onClickFilterButton: () => void
  filtersSelectedCount?: number
}

const FilterButton: FC<FilterButtonProps> = ({
  isFiltersVisible,
  filtersSelectedCount,
  onClickFilterButton,
}) => {
  const { testId } = useQA()
  const { isSkeletonVisible } = useAvoidLayoutShift()
  const isMobileScreen = useIsMobile()

  return isSkeletonVisible ? (
    <Skeleton width={isMobileScreen ? '162px' : '200px'} height='46px' />
  ) : (
    <button
      className={styles.filterButton}
      onClick={onClickFilterButton}
      {...testId('filter-button')}
    >
      <FilterIcon />
      <span>
        {!isFiltersVisible || isMobileScreen ? 'Filters' : 'Hide Filters'}{' '}
        {filtersSelectedCount ? ` (${filtersSelectedCount})` : ``}
      </span>
    </button>
  )
}

export default FilterButton
